import React from 'react';

import NextImage from '../NextImage';
import InlineSVG from '../InlineSVG';
import RenderButtons from '../RenderButtons';

import { CardCarouselPropTypes } from './CardCarousel.types';

const CardCarousel: React.FC<CardCarouselPropTypes> = ({
  carouselItemRef,
  url,
  clinicTitle,
  title,
  description,
  imageClassName,
  titleClassName,
  icon,
  btns,
}) => {
  return (
    <div
      ref={carouselItemRef}
      className='relative flex w-[34.3rem] shrink-0 flex-col items-center justify-between rounded-[0.8rem] border border-[#E6E6E6] md:w-[38rem] md:group-[.post-car]:w-[40%] lg:w-2xl'
    >
      <div className='flex flex-col'>
        <NextImage
          className={`relative w-full rounded-t-[0.8rem] ${imageClassName}`}
          objectFit='cover'
          src={url}
          alt='Test Image'
          aspectRatio={16 / 9}
          width={100}
        >
          <InlineSVG
            src={icon}
            className='align-center absolute! bottom-[0] m-[2rem] flex h-[7.3rem] w-[7.3rem]'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
        </NextImage>

        <div className='px-[1.2rem] pt-[1.8rem] pb-[3rem] md:px-[3rem]'>
          {clinicTitle && (
            <p
              style={{
                textShadow: 'rgb(143, 66, 0, 0.2) 1px 0px 0px, rgb(143, 66, 0, 0.2) 0.540302px 0.841471px 0px',
              }}
              className='text-primary mb-[1.3rem] text-[1.4rem] leading-[2.4rem] font-normal uppercase'
            >
              {clinicTitle}
            </p>
          )}

          <h3
            className={`mb-[1.3rem] text-[2.2rem] leading-[2.8rem] font-normal tracking-[-0.065rem] ${titleClassName}`}
          >
            {title}
          </h3>
          <div className='text-[1.6rem]'>{description}</div>
        </div>
      </div>

      <div className='w-full px-[1.2rem] md:pl-[3rem]'>
        <RenderButtons className='mt-[0]! mb-[2rem] w-full' items={btns} />
      </div>
    </div>
  );
};

export default CardCarousel;
